import Interaction from "../../../models/interactions/Interaction";
import { IShowLetterBox } from "../../../models/interactions/ShowLetterBox";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";
import PiColorPickerField from "../../../components/PiColorPickerField";
import NodeNumberField from "../components/NodeNumberField";

export default function ShowLetterBoxNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const showLetterBox = props.interaction as IShowLetterBox;
  const { updateInteraction } = useUpdateSequenceInteraction();

  const colorPicker = (
    <PiColorPickerField
      label="Color"
      color={showLetterBox.color}
      onChange={(color) =>
        updateInteraction(props.nodeId, {
          ...showLetterBox,
          color: color,
        } as IShowLetterBox)
      }
    />
  );

  const amountInput = (
    <NodeNumberField
      label="Amount"
      value={showLetterBox.amount}
      onChange={(amount: number) =>
        updateInteraction(props.nodeId, {
          ...showLetterBox,
          amount: amount,
        } as IShowLetterBox)
      }
    />
  );

  const animationTimeInput = (
    <NodeNumberField
      label="Animation Time"
      value={showLetterBox.animationTime}
      onChange={(animationTime: number) =>
        updateInteraction(props.nodeId, {
          ...showLetterBox,
          animationTime: animationTime,
        } as IShowLetterBox)
      }
    />
  );

  return (
    <div className="w-full h-full flex flex-col gap-[4px]">
      {colorPicker}
      {/* {amountInput} */}
      {animationTimeInput}
    </div>
  );
}
